import { ApiError } from '@/lib/api'
import { m } from '@/lib/paraglide/messages'

export interface ToastErrorPayload {
    title: string
    description?: string
}

// Builds a sonner toast payload from any thrown error so users see
// the server-supplied message + a trace ID they can quote when reporting.
// `fallback` is the friendly Vietnamese label for the action (e.g.
// "Xác nhận đơn hàng thất bại") used when the error doesn't carry a
// message of its own (network failure, non-API throw).
export function formatApiError(
    err: unknown,
    fallback: string,
): ToastErrorPayload {
    if (err instanceof ApiError) {
        // Prefer the server-supplied human message; keep `fallback` as
        // title only when the API didn't return one (legacy 5xx without
        // body, etc.). Trace ID always surfaces in description.
        const title = err.message || fallback
        const parts: string[] = []
        if (err.code && err.code !== 'UNKNOWN_ERROR') parts.push(err.code)
        if (err.requestId)
            parts.push(m.error_incident_code({ code: err.requestId }))
        return {
            title,
            description: parts.length > 0 ? parts.join(' · ') : undefined,
        }
    }
    return { title: fallback }
}
